import { useApplicationContext } from '../../utils/applicationContext';
import { ExpOfferBookingFormModal } from './experiments';

// TODO: Удалить релизный фича-флаг и эксперимент в CD-292427.
/* istanbul ignore next */
export const useOfferBookingFormModalEnabled = () => {
  const { config } = useApplicationContext();
  const group = ExpOfferBookingFormModal.use();

  return (config.get<boolean>('newbuildingBroker.offerBookingFormModalEnabled') ?? false) && group === 'B';
};
